import { render, staticRenderFns } from "./BrokerPreRegisterEdit.vue?vue&type=template&id=164f44e3&scoped=true"
import script from "./BrokerPreRegisterEdit.vue?vue&type=script&lang=js"
export * from "./BrokerPreRegisterEdit.vue?vue&type=script&lang=js"
import style0 from "./BrokerPreRegisterEdit.vue?vue&type=style&index=0&id=164f44e3&prod&lang=scss&scoped=true"
import style1 from "./BrokerPreRegisterEdit.vue?vue&type=style&index=1&id=164f44e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f44e3",
  null
  
)

export default component.exports